import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'cooldown_reduce',
    apply: ({ state, source, params }) => {
        const amount = params.amount ?? 0.2;
        const r = getRuntimes(state, source.side)[source.slot];
        r.statuses.push({
            id: `cooldown_reduce_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { cooldownReducePct: amount }
        });
    }
});
